import React, { useEffect, useState } from "react";
import "./assigntest.css";
import Swal from "sweetalert2";
import FormInput from "./FormInputs";
import DropDown from "./Dropdown";
import { API_BASE_URL } from "../../Config/Config";
import DropDownUP from "../UploadQuestions/Dropdown";
import DropDownUP2 from "../UploadQuestions/DropdownUP2";

const AssignTest = (dataClient) => {
  const [testId, setTestId] = useState("");
  const [batchId, setBatchId] = useState("");
  const [due_dateId, setDue_dateId] = useState("");
  const [topicId, setTopicId] = useState(null);
  const [subtopics, setSubtopics] = useState([]);
  const [courses, setCourses] = useState([]);
  const [courseOpted, setCourseOpted] = useState("");
  const [subjects, setSubjects] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [topics, setTopics] = useState([]);
  const [selectedChapter, setSelectedChapter] = useState(null);
  const [selectedSubjectLabel, setSelectedSubjectLabel] = useState("");
  const [selectedChapterLabel, setSelectedChapterLabel] = useState("");
  const [selectedSubtopicLabel, setSelectedSubtopicLabel] = useState("");
  const [selectedTopicLabel, setSelectedTopicLabel] = useState("");
  const [selectedSubtopicId, setSelectedSubtopicId] = useState(null);
  const [testNameByID, setTestNameByID] = useState("");
  const [batchnameByCourseID, setBatchNameByCourseID] = useState("");
  const [dropdownKey, setDropdownKey] = useState(0); // Key state for re-render

  const user_name = dataClient.dataClient?.client_schema_name[6][0].user_name;

  useEffect(() => {
    const fetchCourses = async () => {
      const response = await fetch(
        `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-courses/`
      );
      const data = await response.json();
      setCourses(data);
    };

    fetchCourses();
  }, []);

  useEffect(() => {
    const fetchSubjects = async () => {
      if (courseOpted) {
        const response = await fetch(
          `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-subjects-by-course/?course_id=${courseOpted}`
        );
        const data = await response.json();
        setSubjects(data);
        setSelectedSubjectLabel("");
        setSelectedChapterLabel("");
        setSelectedTopicLabel("");
        setTopicId(null);
      }
    };
    fetchSubjects();
  }, [courseOpted]);

  useEffect(() => {
    const fetchChapters = async () => {
      if (selectedSubject) {
        const response = await fetch(
          `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-chapters-by-subject/?subject_id=${selectedSubject}`
        );
        const data = await response.json();
        setChapters(data);
        setSelectedChapterLabel("");
        setSelectedTopicLabel("");
        setTopicId(null);
      }
    };

    fetchChapters();
  }, [selectedSubject]);

  useEffect(() => {
    const fetchTopics = async () => {
      if (selectedChapter) {
        const response = await fetch(
          `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-topics-by-chapter/?chapter_id=${selectedChapter}`
        );
        const data = await response.json();
        setTopics(data);
        setSelectedTopicLabel("");
        setTopicId(null);
      }
    };

    fetchTopics();
  }, [selectedChapter]);

  useEffect(() => {
    const fetchSubtopics = async () => {
      if (topicId) {
        const response = await fetch(
          `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-subtopics-by-topic/?topic_id=${topicId}`
        );
        const data = await response.json();
        setSubtopics(data);
      }
    };

    fetchSubtopics();
  }, [topicId]);

  useEffect(() => {
    const fetchTestNames = async () => {
      const assessmentTypeId = 1;
      const courseId = courseOpted;
      const clientBranchId =
        dataClient.dataClient?.client_schema_name[6][0].client_branch_id;

      let apiUrl = `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-assessment-names/?assessment_type_id=${assessmentTypeId}&course_id=${courseId}&client_branch_id=${clientBranchId}`;

      if (selectedSubject) {
        apiUrl += `&subject_id=${selectedSubject}`;
      }

      if (selectedChapter) {
        apiUrl += `&chapter_id=${selectedChapter}`;
      }

      if (topicId) {
        apiUrl += `&topic_id=${topicId}`;
      }

      try {
        const response = await fetch(apiUrl);
        const data = await response.json();
        setTestNameByID(data);
      } catch (error) {
        console.error("Error fetching test names:", error);
      }
    };

    fetchTestNames();
  }, [topicId, selectedChapter, courseOpted, selectedSubject, dataClient]);

  useEffect(() => {
    const fetchBatch = async () => {
      if (courseOpted) {
        const response = await fetch(
          `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-batch-name-by-course-id/?course_id=${courseOpted}`
        );
        const data = await response.json();
        setBatchNameByCourseID(data);
      }
    };
    fetchBatch();
  }, [courseOpted]);

  useEffect(() => {
    setDropdownKey((prevKey) => prevKey + 1);
  }, [courseOpted, selectedSubject, selectedChapter, topicId]);

  const handleCreate = () => {
    if (!testNameByID || !batchnameByCourseID || !due_dateId) {
      Swal.fire({
        title: "Please fill in all fields",
        icon: "error",
        confirmButtonColor: "rgb(100 101 101)",
      }); 
      return;
    }
    const apiUrl = `${API_BASE_URL}/coaching-collaborator-api/api/v1/assign-dpp-to-batch?assessment_id=${testId}&batch_id=${batchId}&due_date=${due_dateId}&user_name=${user_name}`;

    fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        Swal.fire({
          title: "Success",
          text: "Test Assigned Successfully",
          icon: "success",
          confirmButtonColor: "#318682",
        });
        resetForm();
      })
      .catch((error) => {
        console.error("There was a problem with your fetch operation:", error);
        Swal.fire("Error", "Failed to create data", "error");
      });
  };

  const handleCancel = () => {
    Swal.fire({
      title: "Are you sure you want to cancel?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonColor: "rgb(100 101 101)",
      cancelButtonColor: "#318682",
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload();
      }
    });
  };

  const resetForm = () => {
    setTestId("");
    setBatchId("");
    setDue_dateId("");
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  };

  console.log(testNameByID);
  return (
    <div className="create-role-container">
      <div className="create-role-container-one">
        <span className="create-role-heading">Assign DPP</span>
        <div className="cr-header-btn-container">
          <button className="cr-cancel-btn" onClick={handleCancel}>
            CANCEL
          </button>
          <button className="cr-create-btn" onClick={handleCreate}>
            SAVE
          </button>
        </div>
      </div>
      <div className="personal-info">
        <div className="personal-header">
          <div className="header">
            <h2>Select DPP</h2>
          </div>
          <div className="accordion-btn">
            <div className="minus"></div>
          </div>
        </div>

        <div className="accordion-content">
          <div className="select-test-container">
            <DropDown
              label="Course"
              customWidth="250px"
              setSelected={setCourseOpted}
              options={courses.map((course) => ({
                label: course.course_name,
                id: course.course_id,
              }))}
              isRequired={true}
            />
            <DropDownUP
              label="Subject"
              style={{ width: "250px" }}
              setSelected={setSelectedSubject}
              selectedLabel={selectedSubjectLabel}
              setSelectedLabel={setSelectedSubjectLabel}
              options={subjects.map((subject) => ({
                label: subject.subject_name,
                id: subject.subject_id,
              }))}
            />
            <DropDownUP
              label="Chapter"
              style={{ width: "250px" }}
              setSelected={setSelectedChapter}
              selectedLabel={selectedChapterLabel}
              setSelectedLabel={setSelectedChapterLabel}
              options={chapters.map((chapter) => ({
                label: chapter.chapter_name,
                id: chapter.chapter_id,
              }))}
              Height="auto"
              OverFlow="auto"
              minheight="200px"
            />
            <DropDownUP2
              label="Topic"
              style={{ width: "250px" }}
              setSelected={setTopicId}
              selectedLabel={selectedTopicLabel}
              setSelectedLabel={setSelectedTopicLabel}
              options={topics.map((topic) => ({
                label: topic.topic_name,
                id: topic.topic_id,
              }))}
            />
            <DropDownUP2
              label="Sub-Topic"
              style={{ width: "250px" }}
              setSelected={setSelectedSubtopicId}
              selectedLabel={selectedSubtopicLabel}
              setSelectedLabel={setSelectedSubtopicLabel}
              options={subtopics.map((subtopic) => ({
                label: subtopic.subtopic_name,
                id: subtopic.subtopic_id,
              }))}
            />
          </div>
        </div>
      </div>
      <div className="personal-info">
        <div className="personal-header">
          <div className="header">
            <h2>Assign DPP</h2>
          </div>
        </div>
        <div className="accordion-content">
          <div className="assign-test-container">
            <div className="academic-tile">#</div>
            <div className="academic-tile">DPP Name</div>
            <div className="academic-tile">Batch</div>
            <div className="academic-tile">Due Date</div>
            <div className="class-name">1</div>
            <div className="data">
              <DropDown
                key={dropdownKey}
                setSelected={setTestId}
                options={
                  testNameByID && testNameByID.data
                    ? testNameByID.data.map((assessment_name) => ({
                        id: assessment_name.assessment_id,
                        label: assessment_name.assessment_name,
                      }))
                    : []
                }
                Height="auto"
                minheight="150px"
                OverFlow="auto"
              />
            </div>
            <div className="data">
              <DropDown
                key={dropdownKey}
                setSelected={setBatchId}
                options={
                  batchnameByCourseID && Array.isArray(batchnameByCourseID[0])
                    ? batchnameByCourseID[0].map((batch) => ({
                        label: batch.batch_name,
                        id: batch.batch_id,
                      }))
                    : []
                }
                Height="auto"
                minheight="150px"
                OverFlow="auto"
              />
            </div>
            <div className="data">
              {/* <FormInput
                type="datetime-local"
                onChange={(e) => setDue_dateId(e.target.value)}
                value={due_dateId}
              /> */}
              <FormInput
                type="datetime-local"
                onChange={(e) => setDue_dateId(e.target.value)}
                value={due_dateId}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignTest;
